module.exports = __webpack_public_path__ + "img/HZ-T1494.6607af00.jpg";